import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFSwiperLeftBtn, EFSwiperRightBtn } from '@/components/UI/svg/mm100';
import EFVideo from '@/components/UI/EFVideo';

//用于render重新触发后,值变更了
let activeIndexCur = 0;
let nowPlayIndex = 0;
export default function SwiperA({ data = {}, pagingClass = '', customClass, tab = '', tabHide = false }: any) {
    let videoEnterAOut = tab === 'home';
    const { useState, useLang, useEffect } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { title0 = '', title1, title2, list } = data;
    const [swiper, setSwiper] = useState({ activeIndex: 1 });
    const [active, setActive] = useState(0);
    const [videoEnterA, setVideoEnterA] = useState(videoEnterAOut);
    let controller: any;

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== active && index > -1 && index < list?.length) {
            const newIndex = index % list?.length;
            swiper?.slideTo(newIndex);
            setActive(newIndex);
            activeIndexCur = newIndex;
        }
    };

    useEffect(() => {
        if (tab !== 'home') {
            const sceneA1 = new ScrollMagic.Scene({
                triggerElement: `.swiperAH5`,
                offset: -100, //从开始点滚动多少px触发,可为负数
                triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
                duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
            });

            sceneA1.on('enter', function () {
                !videoEnterAOut && setVideoEnterA(true);
                playVideoFn(activeIndexCur, !videoEnterAOut);
                videoEnterAOut = true;
            });

            controller.addScene(sceneA1);
        }
    }, []);

    useEffect(() => {
        if (tab !== 'home') {
            setVideoEnterA(true);
            nowPlayIndex = 0;
            playVideoFn(1, true);
        }
    }, [tab]);

    const onSlideChangeFn = (swiper: any) => {
        setActive(swiper?.activeIndex % list?.length);
        playVideoFn(swiper?.activeIndex);
        activeIndexCur = swiper.activeIndex;
    };
    const playVideoFn = (index: number, firstEnter: boolean) => {
        if (nowPlayIndex === index && !firstEnter) {
            return;
        }
        const listVideo = document.querySelectorAll('.swiperAH5 .video') || [];
        listVideo.forEach((item: any) => item?.pause());
        // 要停止后,播放放在异步队列播放
        setTimeout(() => {
            listVideo[index]?.play();
        }, 100);
        nowPlayIndex = index;
    };

    return (
        <div className={`${css.swiperAH5} swiperAH5 ${customClass}`}>
            {title0 && <div className="kit-ms0">{title0}</div>}
            <div className="kit-ms1">{title1}</div>
            <div className="kit-ms2">{title2}</div>
            <Swiper
                className={`m100H5-product-swiper ${list?.length === 1 ? 'single' : ''}`}
                slidesPerView={'auto'}
                spaceBetween={0}
                initialSlide={list?.length <= 2 ? 0 : 1}
                preloadImages={false}
                lazy
                centeredSlides
                grabCursor
                onSwiper={(swiper: any) => setSwiper(swiper)}
                onSlideChange={(swiper: any) => onSlideChangeFn(swiper)}
            >
                {list?.map((item: any) => (
                    <SwiperSlide key={item.i18n}>
                        <div className="list-item">
                            <div className="video-box">{videoEnterA && <EFVideo sources={item.src} className={`video ${item.class}`} />}</div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {list?.length > 1 && (
                <div className={`paginations ${pagingClass} ${tabHide ? 'tabHide' : ''}`}>
                    {list?.map((item: any, k: number) => (
                        <li className={`pagination-item ${k === active ? 'active' : ''}`} key={k}>
                            <div className="item-box">
                                <EFSwiperLeftBtn
                                    width="0.32rem"
                                    height="0.32rem"
                                    className={`prevBtn btn ${active > 0 ? 'active' : ''}`}
                                    onClick={() => onSwiperSlideTo(k - 1)}
                                />
                                {item?.i18n && <span className="item-text">{t(`presale.product.${item?.i18n}`)}</span>}
                                <EFSwiperRightBtn
                                    width="0.32rem"
                                    height="0.32rem"
                                    className={`nextBtn btn ${active < list?.length - 1 ? 'active' : ''}`}
                                    onClick={() => onSwiperSlideTo(k + 1)}
                                />
                            </div>
                        </li>
                    ))}
                </div>
            )}
        </div>
    );
}
